/** Swaps the designer's `{%…%}` binding delimiters for Formily's `{{…}}`. */
export const toRuntimeTemplates = <T,>(schema: T): T => {
  if (schema == null) return schema;
  try {
    return JSON.parse(
      JSON.stringify(schema).replace(/\{%/g, '{{').replace(/%\}/g, '}}')
    ) as T;
  } catch {
    return schema;
  }
};
